const theme = {
  light: {
    colors: {
      tileBackground: "#FFFFFF",
      white: "#FFFFFF",
      background: "#FBFBFE",
      mainText: "#252525",
      textSecondary: "#6E7E91",
      blue: "#0366D6",
      linkBorder: "#0366D633",
      linkBorderHover: "#0366D6CC",
      diffBGNeutral: "#D1D5DA4D",
      tileBorder: "rgba(3, 102, 214, 0.20)",
      buttonFocus:
        "-2px -2px 0px 0px #8CC2FF, 2px 2px 0px 0px #8CC2FF, -2px 2px 0px 0px #8CC2FF, 2px -2px 0px 0px #8CC2FF",
      buttonActive: "0px 2px 0px 0px rgba(20, 70, 32, 0.20) inset",
      boxShadow:
        "0px 16px 58px 0px rgba(9, 10, 51, 0.03), 0px -2px 50px 0px rgba(9, 10, 51, 0.02)",
    },
    breakpoints: {
      phoneMedia: 767,
      mediumMedia: 1200,
    },
  },
  dark: {
    colors: {
      tileBackground: "#363636B8",
      white: "#FFFFFF",
      background: "#252525",
      mainText: "#FFFFFF",
      textSecondary: "#FFFFFF",
      blue: "#2188FF",
      linkBorder: "#2188FF66",
      linkBorderHover: "#2188FFCC",
      diffBGNeutral: "#D1D5DA1A",
      tileBorder: "rgba(3, 102, 214, 0.50)",
      buttonFocus:
        "-2px -2px 0px 0px #6D93BE, 2px 2px 0px 0px #6D93BE, -2px 2px 0px 0px #6D93BE, 2px -2px 0px 0px #6D93BE",
      buttonActive: "",
      boxShadow:
        "0px 16px 58px 0px rgba(9, 10, 51, 0.03), 0px -2px 50px 0px rgba(9, 10, 51, 0.02)",
    },
    breakpoints: {
      phoneMedia: 767,
      mediumMedia: 1200,
    },
  },
};

export default theme;
